import { render, staticRenderFns } from "./labelList.vue?vue&type=template&id=5c533f78&scoped=true&"
import script from "./labelList.vue?vue&type=script&lang=js&"
export * from "./labelList.vue?vue&type=script&lang=js&"
import style0 from "./labelList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./labelList.vue?vue&type=style&index=1&id=5c533f78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c533f78",
  null
  
)

export default component.exports